import {useTranslation} from "react-i18next";

export const ErrorMessage = ({ page, error }) => {
    const { t } = useTranslation();

    if (error) {
        return <span className="text-danger small">{t(page+'.error.'+error)}<br/></span>
    }
}
